import { authService } from "@/services/auth"

const JWT_KEY = process.env.VUE_APP_JWT_KEY || "auth_token"

function loadTokens() {
  try {
    return {
      accessToken: localStorage.getItem(`${JWT_KEY}_access`) || null,
      refreshToken: localStorage.getItem(`${JWT_KEY}_refresh`) || null,
    }
  } catch {
    return { accessToken: null, refreshToken: null }
  }
}

const { accessToken, refreshToken } = loadTokens()

export default {
  namespaced: true,

  state: () => ({
    user: null,
    accessToken,
    refreshToken,
    loading: false,
    error: null,
  }),

  getters: {
    isLoggedIn: (state) => !!state.accessToken && !!state.user,
    isTokenPresent: (state) => !!state.accessToken,
  },

  mutations: {
    SET_TOKENS(state, { access, refresh }) {
      state.accessToken = access
      state.refreshToken = refresh
      localStorage.setItem(`${JWT_KEY}_access`, access)
      localStorage.setItem(`${JWT_KEY}_refresh`, refresh)
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_LOADING(state, val) {
      state.loading = val
    },
    SET_ERROR(state, err) {
      state.error = err
    },
    CLEAR(state) {
      state.user = null
      state.accessToken = null
      state.refreshToken = null
      state.error = null
      localStorage.removeItem(`${JWT_KEY}_access`)
      localStorage.removeItem(`${JWT_KEY}_refresh`)
    },
  },

  actions: {
    async login({ commit }, { username, password }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const { data } = await authService.login(username, password)
        commit("SET_TOKENS", { access: data.access, refresh: data.refresh })
        commit("SET_USER", data.user)
      } catch (err) {
        commit("SET_ERROR", err.response?.data?.detail || "Login failed.")
        throw err
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async register({ commit }, { username, email, password, password2 }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const { data } = await authService.register(username, email, password, password2)
        commit("SET_TOKENS", { access: data.access, refresh: data.refresh })
        commit("SET_USER", data.user)
      } catch (err) {
        commit("SET_ERROR", err.response?.data || "Registration failed.")
        throw err
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async fetchMe({ commit, state }) {
      if (!state.accessToken) return
      try {
        const { data } = await authService.me(state.accessToken)
        commit("SET_USER", data)
      } catch {
        commit("CLEAR")
      }
    },

    async refreshToken({ commit, state }) {
      if (!state.refreshToken) throw new Error("No refresh token")
      const { data } = await authService.refresh(state.refreshToken)
      commit("SET_TOKENS", { access: data.access, refresh: state.refreshToken })
      return data.access
    },

    logout({ commit }) {
      commit("CLEAR")
    },
  },
}
